























import { Vue, Component, Prop, Model, Watch } from "vue-property-decorator";
import { Button, Toast } from "vant";
import Routers from "../../../router/RouterTypes";
import * as StoreType from "@/store/StoreTypes";
import store from "@/store";
import { MUTATION_INTER_SET_IM_CONTENT } from "@/store/StoreTypes";
import Api from "@/api";
import handleIm from "./handleIm";
import Wechat from "@/common/Wechat";
import { utils } from "@/components/medical-core";
import Public from "@/common/Public";
import Cons from "@/common/Constants";
import compressImg from "@/common/CompressImg";

Component.registerHooks(["beforeRouteEnter"]);
@Component({
	components: {
		[Button.name]: Button,
	},
})
export default class IMInput extends Vue {
	@Prop({ type: Function, default: () => {} })
	sended;

	@Prop({ type: Object, default: {} })
	doctorMsg;
	@Prop({ type: Object, default: {} })
	patientMsg;
	@Prop({ type: String, default: "" })
	inqueryId;
	@Prop({ type: String, default: "" }) 
	toUser;
	@Prop({ type: String, })
	inquiryType;

	replyImgPic = require("../../../assets/icon_yisheng_nan.png");
	contentText = "";

	get userInfo() {
		return this.$store.state.userInfo;
	}

	// 存储聊天内容（包括聊天记录）
	get chatContent(): string {
		return this.$store.state.interrogation.chatContent;
	}
	// 获取租户信息
	get currentHospital() {
		return this.$store.state.hospital.currentHospital;
	}

	// 发送图片消息
	pictureChange(e) {
		let _this = this;
		let files = e instanceof Event ? (e.srcElement as any).files : e;
		let file = files[0];
		compressImg(file, 1).then((res) => {
			const obj = {
				data: res,
				filename: +new Date() + ".jpg",
				filetype: "jpg",
				url: window.URL.createObjectURL(res),
			};
			_this.sendPrivateImg(obj);
		});
	}

	chooseImage() {
		// (this as any).$addCodeDot("ov_detail_select_picture_click");
		let nativeChoose = () => {
			let input = document.createElement("input");
			input.style.position = "absolute";
			input.style.left = "-9999px";
			input.style.top = "-9999px";
			input.type = "file";
			input.accept = "image/*";
			document.body.appendChild(input);
			input.onchange = this.pictureChange;
			input.click();
		};
		if (
			!utils.isWeixin() ||
			Utils.getSessionCache(Cons.LOGIN_TYPE) === "ticket"
		) {
			nativeChoose();
		} else {
			Wechat.chooseImage()
				.then((res) => {
					this.pictureChange(res);
				})
				.catch(() => {
					nativeChoose();
				});
		}
	}

	inputSend() {
		this.contentText = "";
		this.sended();
	}

	// 发送图片
	sendPrivateImg(obj) {
		// 判断用户是否存在
		if (!this.toUser) {
			this.$pascToast('接收消息用户名错误');
			return false;
		}

		const _this = this;
		const conn: any = this.$imconn;
		let id: any = this.$imconn.getUniqueId();
		const msg: any = new this.$WebIM.message("img", id);
		console.log(this.$WebIM.config,'this.$WebIM.config')
		const option: any = {
			apiUrl: this.$WebIM.config.apiURL,
			file: obj,
			to: this.toUser,
			roomType: false,
			chatType: "singleChat",
			ext: {
				type: "img",
				inqueryId: this.inqueryId,
				fromName: this.patientMsg.patientName,
				toName: this.doctorMsg.doctorName,
				patientId: this.patientMsg.patientId,
				inquiryType: this.inquiryType,
				sentTime: +new Date(),
				// inqueryId: _this.inqueryId,
				// fromName: this.patientMsg.patientName,
				// toName: this.doctorMsg.doctorName,
				// patientUserId: this.userInfo.userId,
				// patientId: this.patientMsg.patientId,
				// sentTime: +new Date(),
				// projectCode: process.env.PASC_HX_PROJECTCODE,
				// inquiryType: this.inquiryType,
			},
			onFileUploadError: function (error) {
				console.log("onFileUploadError",error);
			},
			onFileUploadComplete: function (data) {},
			success: function (id) {
				console.log("发送图片消息");
				console.log(JSON.stringify(msg));
				_this.$store.commit(MUTATION_INTER_SET_IM_CONTENT, msg.body);
				_this.inputSend(); // 发送成功回调
				// ;(_this.$refs.uploadImage as any).value = ""
			},
		};
		msg.set(option);
		console.log(msg.body,'发送图片消息的消息体')
		conn.send(msg.body);
	}

	// 发送文本消息事件
	sendMsg() {
		if (this.contentText === "") {
			Toast('请输入内容');
		} else {
			handleIm.handleReply(
				this.toUser,
				{
					type: "txt",
					// inqueryId用于获取聊天记录
					inqueryId: this.inqueryId,
					fromName: this.patientMsg.patientName,
					toName: this.doctorMsg.doctorName,
					patientId: this.patientMsg.patientId,
					inquiryType: this.inquiryType,
					sentTime: +new Date(),
					// patientUserId: this.userInfo.userId,
				},
				this.contentText,
				this.inputSend
			);
		}
	}

	initScrollBottom() {
		const isAndroid =
			navigator.userAgent.indexOf("Android") > -1 ||
			navigator.userAgent.indexOf("Adr") > -1;
		const isIos = !!navigator.userAgent.match(
			/\(i[^;]+;( U;)? CPU.+Mac OS X/
		);

		if (isAndroid) {
			let fn = () => {
				if (
					document.activeElement.tagName == "INPUT" ||
					document.activeElement.tagName == "TEXTAREA"
				) {
					window.setTimeout(() => {
						// 触发事件
						this.$emit("scrollBottom");
					}, 0);
				}
			};
			window.addEventListener("resize", fn);
			this.$once("hook:beforeDestroy", () => {
				window.removeEventListener("resize", fn);
			});
		} else if (isIos) {
			let fnIn = () => {
				this.$emit("scrollBottom");
			};

			window.addEventListener("focusin", fnIn);
			this.$once("hook:beforeDestroy", () => {
				window.removeEventListener("focusin", fnIn);
			});
		}
	}

	iosKeyMsg() {
		let u = navigator.userAgent;
		let flag;
		let myFunction;
		let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
		const _this = this;
		if (isIOS) {
			document.body.addEventListener("focusin", () => {
				//软键盘弹起事件
				flag = true;
				clearTimeout(myFunction);
				// setTimeout(() => {
				//   document.getElementById('patientMsg').style.top = (document.body.scrollTop-2) + 'px'
				// }, 200)
			});
			document.body.addEventListener("focusout", () => {
				//软键盘关闭事件
				flag = false;
				// document.getElementById('patientMsg').style.top = 0 + 'px'
				if (!flag) {
					myFunction = setTimeout(function () {
						_this.winScroll();
					}, 200);
				} else {
					return;
				}
			});
		} else {
			return;
		}
	}

	winScroll() {
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); //重点  =======当键盘收起的时候让页面回到原始位置
	}

	created() {
		Wechat.getJsApiTicket();
	}
	mounted() {
		let keydownFn = (event) => {
			if (event.keyCode == 13) {
				this.sendMsg();
			}
		};
		document.addEventListener("keydown", keydownFn);
		this.$once("hook:beforeDestroy", () => {
			document.removeEventListener("keydown", keydownFn);
		});
		this.iosKeyMsg();
		this.initScrollBottom();
	}
}
